import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import TeamRequestList from '../../components/teams/TeamRequestList';

export default function TeamRequestsPage() {
  const { orgId } = useParams();
  const [tab, setTab] = useState('PENDING');

  return (
    <>
      <div className="teams-card">
        <h2>Requests & notifications</h2>
        <p className="teams-sub">
          Team workspace invites, assignments, and challenges appear here. Accept workspace invites to join the team.
        </p>
        <div className="teams-segment" role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={tab === 'PENDING'}
            className={tab === 'PENDING' ? 'is-active' : undefined}
            onClick={() => setTab('PENDING')}
          >
            Pending
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={tab === 'ACCEPTED'}
            className={tab === 'ACCEPTED' ? 'is-active' : undefined}
            onClick={() => setTab('ACCEPTED')}
          >
            Accepted
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={tab === 'DECLINED'}
            className={tab === 'DECLINED' ? 'is-active' : undefined}
            onClick={() => setTab('DECLINED')}
          >
            Declined
          </button>
        </div>
      </div>
      <div className="teams-card">
        <TeamRequestList
          orgId={orgId}
          status={tab}
          emptyMessage={
            tab === 'PENDING'
              ? 'Nothing waiting — you’re all caught up.'
              : `No ${tab.toLowerCase()} requests.`
          }
        />
      </div>
    </>
  );
}
